(function() {
  var facadeSelector = '[data-youtube-facade]';
  var buttonSelector = '[data-youtube-facade-button]';
  var preconnected = false;

  function findFacade(target) {
    if (!target || !target.closest) {
      return null;
    }

    return target.closest(facadeSelector);
  }

  function addPreconnect(href) {
    if (document.querySelector('link[rel="preconnect"][href="' + href + '"]')) {
      return;
    }

    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }

  function preconnect() {
    if (preconnected) {
      return;
    }

    preconnected = true;
    addPreconnect('https://www.youtube-nocookie.com');
    addPreconnect('https://www.google.com');
  }

  function buildIframe(videoId, title) {
    var url = new URL('https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId));
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('rel', '0');
    url.searchParams.set('playsinline', '1');

    var iframe = document.createElement('iframe');
    iframe.className = 'youtube-facade__iframe';
    iframe.src = url.toString();
    iframe.title = title || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.loading = 'eager';
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';

    return iframe;
  }

  function activateFacade(facade) {
    if (!facade || facade.dataset.loaded === 'true') {
      return;
    }

    var videoId = facade.dataset.videoId;
    if (!videoId) {
      return;
    }

    facade.dataset.loaded = 'true';
    preconnect();

    var button = facade.querySelector(buttonSelector);
    if (button) {
      button.disabled = true;
    }

    var iframe = buildIframe(videoId, facade.dataset.title);
    facade.textContent = '';
    facade.appendChild(iframe);
    iframe.focus();
  }

  document.addEventListener('click', function(event) {
    var button = event.target.closest ? event.target.closest(buttonSelector) : null;
    if (!button) {
      return;
    }

    var facade = findFacade(button);
    if (!facade) {
      return;
    }

    event.preventDefault();
    activateFacade(facade);
  });

  document.addEventListener('pointerover', function(event) {
    if (findFacade(event.target)) {
      preconnect();
    }
  }, { passive: true });

  document.addEventListener('focusin', function(event) {
    if (findFacade(event.target)) {
      preconnect();
    }
  });

  document.addEventListener('touchstart', function(event) {
    if (findFacade(event.target)) {
      preconnect();
    }
  }, { passive: true });
})();
